<template>
  <div class="blk_greeting_detail">
    <p v-if="carrerLength" class="greeting_detail_title">経歴</p>
    <table class="table_career">
      <tr v-for="list in carrerLists"><th>{{ list[0] }}</th><td>{{ list[1] }}</td></tr>
    </table>
    <p v-if="organizationLength" class="greeting_detail_title">所属</p>
    <ul class="list_organization list list_circle">
      <li v-for="list in organizationLists">{{ list }}</li>
    </ul>
    <p v-if="allianceLength" class="greeting_detail_title">提携病院</p>
    <ul class="list_alliance list list_circle">
      <li v-for="list in allianceLists">{{ list }}</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GreetingDetail',
  props: {
    msg: String
  },
  data () {
    return {
      carrerLists: siteData.about.carrer,
      carrerLength: siteData.about.carrer.length,
      organizationLists: siteData.about.organization,
      organizationLength: siteData.about.organization.length,
      allianceLists: siteData.about.alliance,
      allianceLength: siteData.about.alliance.length
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
